import { render, staticRenderFns } from "./rdsmstest-add-or-update.vue?vue&type=template&id=965d6634&scoped=true&"
import script from "./rdsmstest-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rdsmstest-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./rdsmstest-add-or-update.vue?vue&type=style&index=0&id=965d6634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965d6634",
  null
  
)

export default component.exports